import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

function isStandaloneCourse(pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment) {
  return !(pageData.specializations && pageData.specializations?.length > 0);
}

export default isStandaloneCourse;
